<template>
  <screen-container type="home">
    <div class="row home">
      <div class="row mx-5 mt-5 d-flex justify-content-center w-100">
        <button :class="['mission-card col-sm mt-1', grade === 10 || grade === 0 ? '' : 'active' ]" :disabled="grade !== 10 && grade !== 0 " @click="goToMission(1)">
          <img v-lazy="'/img/misionPresSegundo.png'" class="shadow"  width="100%">
        </button>
        <button :class="['mission-card col-sm mt-1', grade === 11 || grade === 0 ? '' : 'active']" :disabled="grade !== 11 && grade !== 0" @click="goToMission(2)">
          <img v-lazy="'/img/misionPresPrimero.png'" class="shadow"  width="100%">
        </button>
        <button :class="['mission-card col-sm mt-1', grade === 12 || grade === 0 ? '' : 'active']" :disabled="grade !== 12 && grade !== 0 " @click="goToMission(3)">
          <img v-lazy="'/img/misionPresTercero.png'" class="shadow" width="100%">
        </button>
        <button :class="['mission-card col-sm mt-1', grade === 13 || grade === 0 ? '' : 'active']" :disabled="grade !== 13 && grade !== 0 " @click="goToMission('PF')">
            <img v-lazy="'/img/misionPresPF.png'" class="shadow" width="100%">
          </button>
      </div>
    </div>
  </screen-container>
</template>
<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';

export default {
  name: 'home',
  async created() {
    NProgress.done();
    this.init();
  },
  data () {
    return {
      grade: 1,
      trim: 2,
      trims: [
        {
          id:1,
          active:false
        },
        {
          id:2,
          active:true
        }
      ]
    }
  },
  methods: {
    init() {
      let e = localStorage.getItem('userGrade');
      this.grade = parseInt(e ? e : 0)
    },
    logout() {
      Auth.logout();
    },
    goToMission(missionId) {
      if (missionId === 'PF') {
        this.$router.push(`/preek/mission/PF`);
      } else {
        this.$router.push(`/preek/mission/${missionId}`);
      }
    },
    showLogout() {

    }
  },
}
</script>
<style  lang="scss" scoped>
.active {
  img {
    filter: blur(1.8px);
  }
  &.active:hover {
      transform: scale(1);
      cursor: auto;
  }
}
.mission-card {
    background: transparent;
    border: none;
}
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 64vw;
}
@media (max-width: 1440px) {
  .home {
      max-width: 1000px;
  }
}
.login-container {
  background-size: 100% auto;
}
</style>
